import { FiInfo } from "react-icons/fi";
import styles from "./styles.module.scss";
import React from "react";

export default function Title({ text, icon }) {
  return (
    <div className={styles.container}>
      {icon ? icon : <FiInfo color="#F5CB2B" size={40} />}
      <h3>{text}</h3>
    </div>
  )
}